import { Box, Text } from "@chakra-ui/react";

export default function SelectPlaceholder(props: { children: string }) {
  return (
    <Box color="gray.600" fontSize="md" mx={2} p={6} textAlign="center">
      <Text>{props.children}</Text>
    </Box>
  );
}
